import { useState, useEffect } from 'react';
import { API_BASE_URL } from '../../../lib/constants';

export const useNotifications = (userRole) => {
  const [notificationsVisible, setNotificationsVisible] = useState(false);
  const [delayAlerts, setDelayAlerts] = useState([]);
  const [nurseNotifications, setNurseNotifications] = useState([]);

  // Delay alerts (Admin, Doctor, OT Manager)
  useEffect(() => {
    const isClinicalAdmin = userRole === 'Admin' || userRole === 'Doctor' || userRole === 'OT Manager';
    if (isClinicalAdmin) {
      const fetchAlerts = () => {
        fetch(`${API_BASE_URL}/operation_delay_alerts`)
          .then(res => res.json())
          .then(data => {
            if (data.status === 'success') setDelayAlerts(data.data || []);
          })
          .catch(err => console.error('Error fetching delay alerts:', err));
      };
      fetchAlerts();
      const interval = setInterval(fetchAlerts, 30000);
      return () => clearInterval(interval);
    }
  }, [userRole]);

  // Nurse notifications (Nurse, Admin)
  useEffect(() => {
    const shouldSeeNurseNotifs = userRole === 'Nurse' || userRole === 'Admin';
    if (shouldSeeNurseNotifs) {
      const fetchNurseNotifications = () => {
        fetch(`${API_BASE_URL}/get_nurse_notifications`)
          .then(res => res.json())
          .then(data => {
            if (data.notifications) {
              setNurseNotifications(data.notifications.filter(n => n.status === 'pending'));
            }
          })
          .catch(err => console.error('Error fetching nurse notifications:', err));
      };
      fetchNurseNotifications();
      const interval = setInterval(fetchNurseNotifications, 60000);
      return () => clearInterval(interval);
    }
  }, [userRole]);

  const getNotificationCount = () => {
    if (userRole === 'Admin') return delayAlerts.length + nurseNotifications.length;
    if (userRole === 'Nurse') return nurseNotifications.length;
    return delayAlerts.length;
  };

  const getNotificationTitle = () => {
    if (userRole === 'Nurse') return "Pre-Op Orders";
    if (userRole === 'Doctor') return "Surgery Delay Alerts";
    if (userRole === 'Admin') return "All Clinical & Delay Alerts";
    return "Delay Alerts & Notifications";
  };

  return {
    notificationsVisible,
    setNotificationsVisible,
    delayAlerts,
    nurseNotifications,
    getNotificationCount,
    getNotificationTitle
  };
};
